(function () {
    'use strict';

    angular.module("imApp").factory("orderLineMsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1096,
                    parameters: parms || {}
                });
            },
            listSelectModels: function (parms) {
                return $ihttp.post({
                    method: 1097,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
